export default __webpack_public_path__ + "static/media/strasbourg9.9805f11f.jpg";